import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import { tokens } from "./tokens";

interface Props {
    icon?: React.ReactNode;
    label: string;
    asOf?: string;
}

const useStyles = makeStyles(() => ({
    zoneHead: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: "34px 0 14px",
    },
    label: {
        fontSize: "13px",
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        color: tokens.hint,
        display: "flex",
        alignItems: "center",
        gap: "8px",
    },
    icon: {
        display: "flex",
        alignItems: "center",
        color: tokens.hint,
    },
    asOf: {
        fontSize: "12px",
        color: tokens.hint,
    },
}));

export const ZoneHead: React.FC<Props> = ({ icon, label, asOf }) => {
    const classes = useStyles();

    return (
        <div className={classes.zoneHead}>
            <Typography component="h2" className={classes.label}>
                {icon && <span className={classes.icon}>{icon}</span>}
                {label}
            </Typography>
            {asOf && <span className={classes.asOf}>{asOf}</span>}
        </div>
    );
};
